module.exports = __webpack_public_path__ + "img/NL548.334a3235.png";